export default "__VITE_ASSET__Bukyx47R__"